import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import { IMAGE_GEEKO_LTD } from '../../../../../../../../constants'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

export default props => {
    useStyles(classes)
    const {onPaymethod, onPay, paying} = props
    const global = useSelector(state => state.global)

    return <div className={`${classes.Klarna} ${paying? classes.Paying: ''}`}>
        <button className={`${classes.Button} ${global.language === 'fr'? classes.I18:''}`} disabled={paying} onClick={onPay}>
            {
                !paying && <object className={classes.Brand} data={`${IMAGE_GEEKO_LTD}/chicme/20230328/klarna.svg`}/>
            }

            {
                paying && <Iconfont className={classes.LoadIcon}>&#xe62d;</Iconfont>
            }

            <span className={classes.PayNowText}>
                <FormattedMessage id="pay_now" defaultMessage="Pay Now"/>
            </span>
        </button>
        <button className={classes.Select} disabled={paying} onClick={onPaymethod}>
            <Iconfont className={classes.Icon}>&#xe727;</Iconfont>
        </button>
    </div>
}